(() => {
  let dictionaries = null;
  let language = document.documentElement.lang.startsWith('es') ? 'es' : 'en';
  const lookup = key => key.split('.').reduce((value, part) => value?.[part], dictionaries?.[language]);
  const translated = (key, fallback) => lookup(key) || fallback;
  const languageState = () => {
    document.querySelectorAll('[data-language-label]').forEach(label => { label.textContent = language === 'es' ? 'ES / EN' : 'EN / ES'; });
    document.querySelectorAll('[data-language-toggle]').forEach(button => button.setAttribute('aria-label',language === 'es' ? 'Switch to English' : 'Cambiar a español'));
  };
  function applyLanguage() {
    if (!dictionaries) return;
    document.querySelectorAll('[data-i18n]').forEach(element => {
      const text = lookup(element.dataset.i18n);
      if (typeof text === 'string') element.textContent = text;
    });
    document.documentElement.lang = language;
    languageState();
    document.querySelectorAll('[data-planner]').forEach(updatePlanner);
  }
  function updatePlanner(root) {
    const value = name => root.querySelector(`[data-control="${name}"]`);
    const number = (name,min,max) => {
      const input = value(name);
      const numeric = Number(input.value);
      return Math.min(max, Math.max(min, Number.isFinite(numeric) ? numeric : min));
    };
    const result = (name,text) => { const node=root.querySelector(`[data-result="${name}"]`);if(node)node.textContent=text; };
    const format = (number,digits=1) => new Intl.NumberFormat(language,{minimumFractionDigits:digits,maximumFractionDigits:digits}).format(number);
    root.querySelectorAll('[data-value]').forEach(output => {
      const input=value(output.dataset.value);
      output.textContent=input.value+(input.dataset.unit||'');
    });
    const watts=number('watts',1,1000);
    const solarSoc=number('solar_soc',0,100);
    const batteryInput=Math.min(60,60*number('irradiance',100,1100)/1000*Math.max(.15,Math.cos(number('angle',0,80)*Math.PI/180))*Number(value('glass').value))*.88;
    const remainingWh=296*(1-solarSoc/100);
    result('solar_watts',`${format(batteryInput)} W`);
    result('solar_daily',`${format(Math.min(296,batteryInput*5),0)} Wh`);
    result('solar_hours',remainingWh===0?translated('general.zero_time',language==='es'?'Carga completa':'Fully charged'):batteryInput>2?`${format(remainingWh/batteryInput)} h`:translated('general.low_solar','—'));
    const mode=value('mode').value;
    const usable=296*number('runtime_soc',0,100)/100*(mode==='ac'?.85:.9);
    result('usable_wh',`${format(usable,0)} Wh`);
    result('runtime_hours',mode==='ac'&&watts>300?'—':`${format(usable/watts)} h`);
    result('limit',mode==='ac'?(watts>300?translated('general.not_supported',language==='es'?'El consumo supera 300 W':'Load exceeds 300W AC'):translated('planner.limit',language==='es'?'Dentro del límite CA de 300 W':'Within 300W AC limit')):translated('planner.dc_limit',language==='es'?'Revisa la potencia de cada puerto':'Check each DC / USB port rating'));
  }
  function initialize(root=document) {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if(gallery.dataset.plReady)return;
      gallery.dataset.plReady='true';
      const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
      const active=gallery.querySelector('.pl-active-image');
      const full=gallery.querySelector('[data-gallery-full]');
      if(!thumbs.length||!active||!full)return;
      let index=Math.max(0,thumbs.findIndex(button=>button.getAttribute('aria-pressed')==='true'));
      const choose=position=>{
        index=(position+thumbs.length)%thumbs.length;
        const thumb=thumbs[index];
        active.src=thumb.dataset.src;
        if(thumb.dataset.srcset)active.srcset=thumb.dataset.srcset;else active.removeAttribute('srcset');
        active.alt=thumb.dataset.alt||'';
        full.href=thumb.dataset.full;
        thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      };
      thumbs.forEach((button,i)=>button.addEventListener('click',()=>choose(i)));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>choose(index-1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>choose(index+1));
      gallery.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();choose(index+(event.key==='ArrowRight'?1:-1));thumbs[index].focus();}});
    });
    root.querySelectorAll('[data-planner]').forEach(planner=>{
      if(planner.dataset.plReady)return;
      planner.dataset.plReady='true';
      planner.addEventListener('input',()=>updatePlanner(planner));
      planner.querySelectorAll('[data-load]').forEach(button=>button.addEventListener('click',()=>{
        planner.querySelector('[data-control="watts"]').value=button.dataset.load;
        planner.querySelector('[data-control="mode"]').value=button.dataset.mode;
        updatePlanner(planner);
      }));
      updatePlanner(planner);
    });
    root.querySelectorAll('[data-variant-select]').forEach(select=>{
      if(select.dataset.plReady)return;
      select.dataset.plReady='true';
      select.addEventListener('change',()=>{
        const option=select.selectedOptions[0];
        const section=select.closest('[data-product-section]');
        const price=section?.querySelector('[data-product-price]');
        if(price)price.textContent=option.dataset.price;
        const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
      });
    });
    root.querySelectorAll('[data-language-toggle]').forEach(button=>{
      if(button.dataset.plReady)return;
      button.dataset.plReady='true';
      button.addEventListener('click',async()=>{
        if(!dictionaries)await loadDictionaries();
        if(!dictionaries)return;
        language=language==='en'?'es':'en';
        try{localStorage.setItem('purlink-language',language);}catch{}
        applyLanguage();
      });
    });
    root.querySelectorAll('.pl-mobile-links a').forEach(link=>link.addEventListener('click',()=>link.closest('details')?.removeAttribute('open')));
    languageState();
  }
  let dictionaryPromise;
  function loadDictionaries(){
    if(!dictionaryPromise){
      const url=document.body.dataset.i18nUrl;
      dictionaryPromise=fetch(url).then(response=>{if(!response.ok)throw new Error('Translations unavailable');return response.json();}).then(data=>{dictionaries=data;}).catch(()=>{dictionaryPromise=null;});
    }
    return dictionaryPromise;
  }
  initialize();
  try{
    const preferred=localStorage.getItem('purlink-language');
    if(preferred==='en'||preferred==='es'){language=preferred;loadDictionaries().then(applyLanguage);}
  }catch{}
  document.addEventListener('shopify:section:load',event=>{initialize(event.target);applyLanguage();});
})();
